var exports = {
  "_": "xe533113f--38345b--thumbnails",
};

module.exports = exports;
